import { OpalWordmark } from '@opallabs/beacon'
import { Size } from '@opallabs/gem'
import { Icon, Link } from '@opallabs/lapidary'
import type { ShareGateProps } from '../types'
import * as styles from './styles'
import type { LearnMoreProps } from './types'

function learnMoreLink({
  includeExternalLink,
  theme,
}: LearnMoreProps): JSX.Element | null {
  if (!includeExternalLink) return null

  return (
    <p>
      <Link
        href="https://www.workwithopal.com"
        styleOverrides={styles.learnMore({ theme })}
        target="_blank"
        theme={theme}
      >
        Learn More About Opal
      </Link>
    </p>
  )
}

function sharedBy(sharerName?: string): string {
  if (!sharerName || sharerName.trim() === '') {
    return 'An Opal presentation has been shared with you.'
  }

  return `${sharerName} wants to share an Opal presentation with you.`
}

export const ShareGateHeader = ({
  includeExternalLink = true,
  sharerName,
  theme,
}: ShareGateProps): JSX.Element => {
  return (
    <div css={styles.container}>
      <div css={styles.themeBlock({ theme })}>
        <div css={styles.colorBlock}>
          <Icon
            ariaMode="hidden"
            glyph="gem-opal-logo"
            height={Size.Icon}
            styleOverrides={{
              container: styles.logoOverlay,
            }}
            width={Size.Icon}
          />
        </div>

        <div css={styles.themeBlockContent}>
          <div css={styles.logo}>
            <OpalWordmark includeLogo={true} theme={theme} />
          </div>

          <h1 css={styles.sharedBy}>{sharedBy(sharerName)}</h1>

          <p css={styles.explanation}>
            Opal is a software platform that creates visibility and alignment
            for marketing and communications teams.
          </p>

          {learnMoreLink({ includeExternalLink, theme })}
        </div>
      </div>
    </div>
  )
}
